const isUrlAbsolute = (url: string) =>
  /^(https|http):\/\/|blob:|data:/.test(url);

export default isUrlAbsolute;
